export default "__VITE_ASSET__edbd8bb4__"